<template lang="pug">
.container.page
  h1 FAQ
  .questions
    .question(v-for='question in questions')
      h5 {{ question.question }}
      b-card
        p {{ question.answer }}
</template>

<style lang="scss" scoped>
  .page {
    padding-top: 4em;
  }

  h2 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .questions {
    max-width: 800px;
    margin: 0 auto;
    margin-top: 3rem;
    margin-bottom: 6rem;
    text-align: left;

    img {
      max-width: 100%;
    }

    .question {
      padding-top: 2rem;
      padding-bottom: 2rem;
      border-bottom: 1px solid #efefef;
    }

    .question:hover {
      cursor: pointer;
    }
  }
</style>

<script>
export default {
  data() {
    return {
      questions: [
        {
          question: 'What is a Sprite?',
          answer: 'A Sprite is a small elemental creature that has unique attributes that will show as it grows and evolves. Your Sprites will gain experience to grow and evolve as you enter them in battle events with your integrated apps.',
        },
        {
          question: 'How do I get my Sprite to grow and evolve?',
          answer: 'Your Sprite will gain EXP (Experience Points) to grow and evolve from a baby into an adult with unique and mystical qualities. Your Sprite gains EXP as you enter it into Battle Events with your integrated apps and complete tasks.',
        },
        {
          question: 'How do I get more Sprites?',
          answer: 'Coming soon :D',
        },
        {
          question: 'How do I fight a monster?',
          answer: 'You can fight a monster with one of your Sprites by integrating apps with Spritely and then creating events that track your progress in those apps. Simply click the “Create Event” button on your Dashboard and choose which of your Sprites will battle a randomly chosen enemy with a difficulty level you can set. Then choose which integrated app you’d like to attach to the event, and which actions in your chosen integrated app you’d like to count towards your monster battle. As you complete the actions you selected in your integrated app of choice, your Sprite will strike at the enemy automatically!',
        },
        {
          question: 'Can monsters hurt my Sprite?',
          answer: 'If you do not do any actions in your integrated app for a period of time, the monster your Sprite is battling may strike! You’ll see a countdown to the next strike from the monster noted on the Event card on your dashboard. Strikes lower your Sprite’s health, and the severity of strikes depends on the difficulty level you set for your event. If your Sprite’s health reaches zero, you will lose the event.',
        },
        {
          question: 'What happens if I lose a battle?',
          answer: 'If your Sprite’s health reaches zero, you will lose the battle with the enemy. When this happens, your event will end and you will have the option to try again. Your Sprite will start its next event with full health.',
        },
        {
          question: 'What apps can I integrate with Spritely and how do I add them?',
          answer: 'You can integrate Habitica and Github with Spritely to track your activity and grow and battle your Sprites. To add an integration, simply click the image of the app you want to add under “Integrations” on your dashboard. If you’d like to suggest more apps for us to add to integrations, please let us know via our Discord: https://discord.gg/ZDxTYQx',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/FAQ.vue